// Basic UI components
export { AIGlowBorder } from './AIGlowBorder';
export { Button } from './Button';
export { Card, CardHeader, CardContent, CardFooter } from './Card';
export { Input } from './Input';
export { UploadIcon } from './UploadIcon';
export { LoadingSpinner } from './LoadingSpinner';
export { LoadingButton } from './LoadingButton';
export { LoadingAnimation } from './LoadingAnimation';
export { Skeleton } from './Skeleton';
export { EmptyState } from './EmptyState';
export { PromoBenefits, type PromoChip } from './PromoBenefits';
export { NoticeBanner, getNoticeBannerActionClasses } from './NoticeBanner';
export type { NoticeBannerVariant } from './NoticeBanner';
export { AngleDeleteConflictDialog } from './AngleDeleteConflictDialog';
export { Breadcrumb, type BreadcrumbItem } from './Breadcrumb';
export { CircularAddButton } from './CircularAddButton';
export { ThemeSwitcher } from './ThemeSwitcher';

// Navigation
export { FloatingActionButton } from './FloatingActionButton';
export { PageActionsMenu } from './PageActionsMenu';

// Layout
export { DesktopShell, HERO_WASH_GRADIENT } from './DesktopShell';

// Header subcomponents
export {
  HistoryButtonWithQueue,
  UserAccountButton,
  HistorySearchInput,
} from './header';
export {
  NestedSheet,
  NestedSheetContent,
  NestedSheetHeader,
  NestedSheetTitle,
  NestedSheetBody,
  NestedSheetStackProvider,
  useNestedSheetStack,
} from './NestedSheet';

// Image components
export { ImageViewer, viewerRectFromElement } from './ImageViewer';
export type { ViewerSourceRect } from './ImageViewer';
export { ImageComparisonSlider } from './ImageComparisonSlider';
export {
  UnifiedImageUpload,
  type UnifiedImageUploadRef,
} from './UnifiedImageUpload';
export { getEffectiveType } from '@/shared/lib/file-validation';
export { UnifiedImageCropModal } from './UnifiedImageCropModal';
export { StackedImages } from './StackedImages';
export {
  FileUploadDropZone,
  type FileUploadDropZoneRef,
} from './FileUploadDropZone';

// Form components
export { SegmentedControl } from './SegmentedControl';
export { ColorPickerPopover } from './ColorPickerPopover';
export { ProtectedButton } from './ProtectedButton';
export { FavoriteButton } from './FavoriteButton';
export { useConceptFavorite } from './use-concept-favorite';

// Settings components (iOS/Android style)
export {
  SettingsCard,
  SettingsRowGroup,
  PickerRow,
  SettingsItem,
  SettingsDisplayProvider,
  useSettingsDisplay,
} from './settings';

// Feedback components
export { ConnectionStatusIndicator } from './ConnectionStatus';
export { GlobalLoadingBar } from './GlobalLoadingBar';
export { InlineLoading } from './InlineLoading';
export { QueueSpinner } from './QueueSpinner';
export { HistoryActivityIcon, type HistoryActivityIconSize } from './HistoryActivityIcon';
export { PulsingDots } from './PulsingDots';

// Utility components
export { default as KeyboardHint } from './KeyboardHint';
export { default as KeyboardShortcutsHelp } from './KeyboardShortcutsHelp';

// Feedback folder
export { default as RateLimitWarning } from './feedback/RateLimitWarning';

// Error boundaries
export { default as ErrorBoundary } from './errors/ErrorBoundary';
export { SentryErrorBoundary } from './errors/SentryErrorBoundary';
export { ProjectSubpageLayout } from './ProjectSubpageLayout';
